import { render } from "./ByMoneyballStick.vue?vue&type=template&id=7b9e356a"
import script from "./ByMoneyballStick.vue?vue&type=script&lang=js"
export * from "./ByMoneyballStick.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__